module.exports = __webpack_public_path__ + "static/media/dash-mobile.c6544320.svg";